import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { AttachmentIcon, PlusIcon } from '@fiverr-private/icons';
import { translate } from '@fiverr-private/i18n-react';
import { useBriefContext } from '../../../common/BriefContext';
import { SectionTypes } from '../../../types';

interface ChipProps {
  title: string;
  onClick: () => void;
}

export const Chip = ({ title, onClick }: ChipProps) => {
  const { isBriefInEditMode } = useBriefContext();
  const isAttachmentChip = title === 'Attachments';

  return (
    <Stack
      width="fit-content"
      cursor={isBriefInEditMode ? undefined : 'pointer'}
      onClick={onClick}
      direction="row"
      gap="2"
      borderColor="grey_500"
      borderStyle="solid"
      borderWidth="sm"
      paddingX="4"
      paddingY="2"
      borderTopLeftRadius="none"
      borderTopRightRadius="3xl"
      borderBottomRightRadius="3xl"
      borderBottomLeftRadius="xl"
    >
      <Text overflow="hidden" size="b_sm">
        <Stack gap="2" direction="row" alignItems="center" justifyContent="flexStart">
          {isAttachmentChip ? <AttachmentIcon size={16} /> : <PlusIcon color="black" size={12} />}
          <Text size="b_sm" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" color="bodyPrimary">
            {isAttachmentChip ? translate('ai_brief.edit_brief.upload_files') : title}
          </Text>
        </Stack>
      </Text>
    </Stack>
  );
};

export const isAttachmentsSection = (section) => section?.type === SectionTypes.attachments;
